module.exports = __webpack_public_path__ + "static/cai_imagery_transparent-ae2b9852d759d6ad56cf908f2af3bb4c.png";